// extracted by mini-css-extract-plugin
export default {"menu":"FeedCardUsersReacted_menu__fS6AM","menu_item":"FeedCardUsersReacted_menu_item__wHX0z","menu_item_img":"FeedCardUsersReacted_menu_item_img__XAgLT"};